module.exports = __webpack_public_path__ + "img/cellphones.a4b3b7d3.webp";